import { makeStyles } from "tss-react/mui";

const fontSize = {
  largeTitle: "33px",
  title1: "27px",
  title2: "21px",
  title3: "19px",
  headline: "17px",
  body: "16px",
  callout: "15px",
  subHeader: "14px",
  label: "11px",
  caption: "10px",
  overline1: "12px",
  overline2: "10px",
  footnote: "12px",
};

const lineHeight = {
  largeTitle: "41.42px",
  title1: "33.89px",
  title2: "26.36px",
  title3: "23.85px",
  headline: "21.34px",
  body: "20.08px",
  callout: "18.83px",
  subHeader: "17.57px",
  label: "13.81px",
  caption: "12.55px",
  overline1: "15.06px",
  overline2: "12.55px",
  footnote: "15.06px",
};

export const useTypographyStyles = makeStyles()({
  // base
  textRegular: {
    fontFamily: "Mulish",
    fontWeight: 400,
  },
  textBold: {
    fontFamily: "Mulish",
    fontWeight: 600,
  },
  //   typography
  largeTitle: {
    fontSize: fontSize.largeTitle,
    lineHeight: lineHeight.largeTitle,
  },
  title1: {
    fontSize: fontSize.title1,
    lineHeight: lineHeight.title1,
  },
  title2: {
    fontSize: fontSize.title2,
    lineHeight: lineHeight.title2,
  },
  title3: {
    fontSize: fontSize.title3,
    lineHeight: lineHeight.title3,
  },
  headline: {
    fontSize: fontSize.headline,
    lineHeight: lineHeight.headline,
  },
  body: {
    fontSize: fontSize.body,
    lineHeight: lineHeight.body,
  },
  callout: {
    fontSize: fontSize.callout,
    lineHeight: lineHeight.callout,
  },
  subhead: {
    fontSize: fontSize.subHeader,
    lineHeight: lineHeight.subHeader,
  },
  label: {
    fontSize: fontSize.label,
    lineHeight: lineHeight.label,
  },
  caption: {
    fontSize: fontSize.caption,
    lineHeight: lineHeight.caption,
  },
  overline1: {
    fontSize: fontSize.overline1,
    lineHeight: lineHeight.overline1,
  },
  overline2: {
    fontSize: fontSize.overline2,
    letterSpacing: "2px",
    lineHeight: lineHeight.overline2,
    textTransform: "uppercase",
  },
  footnote: {
    fontSize: fontSize.footnote,
    lineHeight: lineHeight.footnote,
    letterSpacing: "-0.5px",
  },
});
